import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClassRoomOnlineService {
  routeParams: any;
  groupsubjs: any[];
  groupsubj: any;
  onGroupsubjsChanged: BehaviorSubject<any>;
  onGroupsubjChanged: BehaviorSubject<any>;
  constructor(private _httpClient: HttpClient) {
    this.onGroupsubjsChanged = new BehaviorSubject({});
    this.onGroupsubjChanged = new BehaviorSubject({});
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    this.routeParams = route.params;

    return new Promise<void>((resolve, reject) => {
      Promise.all([]).then(() => {
        resolve();
      }, reject);
    });
  }

  getCheckClassRoom(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/academic/getCheckClassRoom?ids=${data.Ids}&date=${data.date}`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });

  }
  saveCheckClass(data) {

    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/academic/saveCheckClass`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }
  getClassRoomOnline(id?) {
    if (id) {
      return new Promise<any>((resolve, reject) => {
        this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/${id}/get`).toPromise()
          .then(res => {
            resolve(res);
          }, err => reject(err));
      });
    } else {
      return new Promise<any>((resolve, reject) => {
        this._httpClient.get<any>(`${environment.apiUrl}/classroomonline`).toPromise()
          .then(res => {
            resolve(res);
          }, err => reject(err));
      });
    }

  }

  getSubjectTeachToday(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/academic/getSubjectTeachToday`, { params: data }).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getClassRoomOnlineStd(id?) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/${id}/getStd`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  saveCheckClassStd(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/${data.id}/saveClass`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  saveQuiz(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/${data.id}/saveQuiz`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getDataMerge(id?) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/${id}/getDataMerge`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  deleteQuiz(id) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/deleteQuiz`, id).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  copyQuiz(id) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/copyQuiz`, id).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getEdit(id?) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/${id}/getEdit`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  updateQuiz(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/${data.id}/updateQuiz`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  //ภาระงาน

  saveWork(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient
        .post<any>(`${environment.apiUrl}/classroomonline/saveWork`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  deleteWork(id) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/deleteWork`, id).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getEditWork(id?) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/${id}/getEditWork`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  updateWork(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/updateWork`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getMySubject() {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/homework/getMySubject`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  //
  saveAddClassRoomOnline(data) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/saveAddClassRoomOnline`, data).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  getAddClassRoomOnline() {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.get<any>(`${environment.apiUrl}/classroomonline/getAddClassRoomOnline`).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }


  removeClassRoomOnline(id) {
    return new Promise<any>((resolve, reject) => {
      this._httpClient.post<any>(`${environment.apiUrl}/classroomonline/${id}/removeClassRoomOnline`, id).toPromise()
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }


}
